import React from 'react';
import ManagerSidebar from './ManagerSidebar';
import ManagerTopBar from './ManagerTopbar';
import { Outlet, useLocation } from 'react-router-dom';

function ManagerDashboard() {
  const location = useLocation();
  const isAccountSetting = location.pathname.includes('/manager/dashboard/account');
  const isWhatsAppRoute = location.pathname.includes('/manager/dashboard/whatsapp');

  return (
    <>
      <ManagerTopBar />
      <div className="Dashboard">
        <ManagerSidebar />
        <div className={`AdminDashboard ${isAccountSetting || isWhatsAppRoute ? 'p-0' : ''}`}>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ManagerDashboard;
